<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts';
require('echarts/theme/macarons'); // echarts theme
import resize from '@/views/common/dashboard/admin/components/mixins/resize';

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '400px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons');
      this.setOptions(this.chartData);
    },
    setOptions() {
      this.chart.setOption({
        // x轴数据   **必备条件**
        xAxis: this.chartData.xAxis,
        // y轴数据   **必备条件**
        yAxis: this.chartData.yAxis,
        // 总数据    **必备条件**
        series: this.chartData.series,
        // 数据库标题
        title: this.chartData.title,
        // 数据图占据表格格式
        grid: this.chartData.grid,
        // 鼠标移入显示信息框
        tooltip: this.chartData.tooltip,
        // 数据图右上角icon按钮  （英文模式下会显示中文提示，不建议使用）
        toolbox: this.chartData.toolbox,
        // 数据图底部选中进度条
        dataZoom: this.chartData.dataZoom,
        // 数据库内数据表标题
        legend: this.chartData.legend,
        // 数据图背景色
        areaStyle: this.chartData.areaStyle,
      });
    }
  }
};
</script>

